import { performanceCount } from 'crm-common';

const { PAGE_NAME } = performanceCount;
const API_DOMAIN = '';

// 部门业绩共享api
const DEPARTMENT_API_COMMON = {
  method: 'get',
  url: `${API_DOMAIN}/api/datakanban/queryDepaPerformanceReport`,
};

// 客户贡献共享api
const CUSTOMER_API_COMMON = {
  method: 'get',
  url: `${API_DOMAIN}/api/datakanban/queryCustomerPaymentTopReport`,
};

const CHART_API_CONFIG = {
  // 二级部门业绩
  [PAGE_NAME.department2]: DEPARTMENT_API_COMMON,
  // 三级部门业绩
  [PAGE_NAME.department3]: DEPARTMENT_API_COMMON,
  // 业务员业绩
  [PAGE_NAME.salesman]: {
    method: 'get',
    url: `${API_DOMAIN}/api/datakanban/queryUserAchievementReport`,
  },
  // 产品线业绩
  [PAGE_NAME.productline]: {
    method: 'get',
    url: `${API_DOMAIN}/api/datakanban/queryBusinessLineReport`,
  },
  // [PAGE_NAME.productlineOfDepartment]: {
  //   method: 'get',
  //   url: `${API_DOMAIN}/api/datakanban/queryDepaProductReport`,
  // },
  // 产品线业绩 - 二级部门
  [PAGE_NAME.productlineOfDepartment2]: {
    method: 'get',
    url: `${API_DOMAIN}/api/datakanban/queryDepaProductReport`,
  },
  // 产品线业绩 - 三级部门
  [PAGE_NAME.productlineOfDepartment3]: {
    method: 'get',
    url: `${API_DOMAIN}/api/datakanban/queryFourLevelDepaReport`,
  },
  // 产品线业绩 - 客户贡献
  [PAGE_NAME.productlineOfCustomer]: {
    method: 'get',
    url: `${API_DOMAIN}/api/datakanban/queryCustomerTypeRPReport`,
  },
  // 客户贡献
  [PAGE_NAME.customer]: {
    method: 'get',
    url: `${API_DOMAIN}/api/datakanban/queryCustomerTypeRevenueReport`,
  },
  // 客户贡献 - 分行业
  [PAGE_NAME.customerOfInsurance]: CUSTOMER_API_COMMON,
  [PAGE_NAME.customerOfBank]: CUSTOMER_API_COMMON,
  [PAGE_NAME.customerOfOperator]: CUSTOMER_API_COMMON,
  [PAGE_NAME.customerOfHealth]: CUSTOMER_API_COMMON,
  [PAGE_NAME.customerOfInternet]: CUSTOMER_API_COMMON,
  // 销售业绩统计
  [PAGE_NAME.salesPerformance]: {
    method: 'get',
    url: `${API_DOMAIN}/api/datakanban/querySalesPerformance`,
  },
};

export default CHART_API_CONFIG;
